module.exports = __webpack_public_path__ + "img/text-logo.4a5cb257.png";